'use client'

import { TopModalWithBigcategories } from '@/app/ui/parts/default/sp/modalWithBigcategory'
import { TopModal } from '@/app/ui/parts/default/sp/topModal'
import { bigcategoryType, getBigcategories } from '@/lib/bigcategory/server'
import { categoryType, getCategories } from '@/lib/category'
import { serviceType } from '@/lib/service/server'
import { getSubcategories, subcategoryType } from '@/lib/subcategory'
import { useEffect, useState } from 'react'

export const ClientModal = ({
  service,
  text,
  icon = false,
}: {
  service: serviceType
  text?: string
  icon?: boolean
}) => {
  const [categories, setCategories] = useState<categoryType[]>([])
  const [bigcategories, setBigcategories] = useState<bigcategoryType[]>([])
  const [subcategories, setSubcategories] = useState<subcategoryType[]>([])
  useEffect(() => {
    const fetchData = async () => {
      const [bigcategoriesData, categoriesData, subcategoriesData] =
        await Promise.all([
          getBigcategories(service.service_id),
          getCategories(service.service_id),
          getSubcategories(service.service_id),
        ])
      setBigcategories(bigcategoriesData)
      setCategories(
        categoriesData.map((v) => ({
          ...v,
          seo_text: '',
          faq: '',
          created_at: '',
          updated_at: '',
          description: '',
        })),
      )
      setSubcategories(subcategoriesData)
    }
    fetchData().catch((error) => {
      console.error('Error fetching data:', error)
    })
  }, [service.service_id])
  if (bigcategories.length > 0) {
    return (
      <TopModalWithBigcategories
        service={service}
        text={text}
        icon={icon}
        bigcategories={bigcategories}
      />
    )
  }
  return (
    <TopModal
      service={service}
      text={text}
      icon={icon}
      categories={categories}
      subcategories={subcategories}
    />
  )
}
